import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ArrowDownIcon from "../../assets/icons/arrowdown.svg";
import ArrowUpIcon from "../../assets/icons/arrowup.svg";
import { axios } from "../../utils/axios";
import { formatDateToEEE_MM_d } from "../../utils/utils";
import Skeleton from "react-loading-skeleton";
import { DotsLoader } from "../../components/DotsLoader";
const BookingConfirmation = () => {
  const navigate = useNavigate();
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [paymentMessage, setPaymentMessage] = useState();
  const [status, setStatus] = useState("inProgress");
  const [returnUrl, setReturnUrl] = useState();
  const [loader, setLoader] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [billDetails, setBillDetails] = useState([]);
  const [refID, setRefID] = useState("");
  const [showRoomDetails, setShowRoomDetails] = useState(false);
  const [totalAmount, setTotalAmount] = useState();
  const roomDetailsRef = useRef(null);
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");
  const payment_intent = params.get("payment_intent");
  const tid = params.get("tid");
  const bid = params.get("bid");
  useEffect(() => {
    if (returnUrl && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            localStorage.removeItem("token");
            window.location.href = returnUrl; // Navigate to returnUrl
            return 0;
          }
          return prev - 1;
        });
      }, 1000); // Update every second
      return () => clearInterval(timer); // Cleanup on unmount or returnUrl change
    }
  }, [returnUrl, countdown]);
  useEffect(() => {
    if (sessionId) {
      fetchBookingDetails(sessionId);
    } else if (payment_intent && !sessionId) {
      navigate(
        `/booking-confirmation?bid=${bid}&session_id=${payment_intent}&tid=${tid}`
      );
    }
    // const timer = setTimeout(() => {
    //   navigate("/trips");
    // }, 5000);
    // return () => clearTimeout(timer);
  }, [payment_intent]);
  const fetchBookingDetails = async (sessionId) => {
    setLoader(true);
    let url = `${process.env.REACT_APP_BACKEND_ZENTRUM}stripecomplete?session_id=${sessionId}&bid=${bid}`;
    if (tid) {
      url += `&tid=${tid}`;
    }
    axios
      .get(url)
      .then((resp) => {
        setStatus("confirmed");
        setPaymentDetails(resp?.data?.data?.bookingDetails);
        setRefID(resp?.data?.data?.sevenlyRefID);
        setLoader(false);
        setBillDetails(resp?.data?.data?.priceBreakup);
        setTotalAmount(resp?.data?.data?.totalAmount);
        setReturnUrl(resp?.data?.data?.returnUrl);
      })
      .catch((err) => {
        console.log(err);
        setStatus("failed");
        setLoader(false);
      });
  };
  const toggleRoomDetails = (id) => {
    setShowRoomDetails((prevId) => (prevId === id ? null : id));
  };
  return (
    <div className="bgsearch">
      <div className="container py-5">
        {/* <h1>Your Booking has been confirmed.</h1> */}
        <div className="">
          {status === "inProgress" && (
            <div className="d-flex justify-content-start align-items-end">
              {" "}
              <h1 className="me-3">
                {" "}
                Your Booking is in{" "}
                <span style={{ color: "var(--yellow-color)" }}>
                  Progress
                </span>{" "}
              </h1>
              <DotsLoader />
            </div>
          )}
          {status === "confirmed" && (
            <>
              <h1>
                {" "}
                Your Booking is{" "}
                <span
                  style={
                    paymentDetails &&
                    paymentDetails[0]?.bookingStatus === "Failed"
                      ? { color: "var(--red-color)" }
                      : { color: "var(--primary-color)" }
                  }
                >
                  {paymentDetails && paymentDetails[0]?.bookingStatus} !
                </span>{" "}
              </h1>
              {returnUrl && (
                <p>
                  Your booking is completed now redirecting in{" "}
                  <span style={{ color: "var(--primary-color)" }}>
                    {countdown}
                  </span>{" "}
                  seconds...
                </p>
              )}
            </>
          )}
          {status === "failed" && (
            <>
              <h1>
                Your Booking is{" "}
                <span style={{ color: "var(--red-color)" }}>Failed!</span>{" "}
              </h1>
              <p>
                Your booking could not be completed. If any amount was deducted,
                it will be automatically refunded to your original payment
                method within 2–3 business days.
              </p>
              {returnUrl && (
                <p>
                  Your booking failed now redirecting in{" "}
                  <span style={{ color: "var(--primary-color)" }}>
                    {countdown}
                  </span>{" "}
                  seconds...
                </p>
              )}
            </>
          )}
        </div>

        {loader ? (
          <Skeleton height={30} width={"30%"} />
        ) : (
          <p>Booking ID : {refID}</p>
        )}

        {loader ? (
          <>
            <div className="row mt-4">
              <div className="col-md-8">
                <Skeleton height={600} />
              </div>
              <div className="col-md-4">
                <Skeleton height={600} />
              </div>
            </div>
          </>
        ) : (
          <div className="row mt-4">
            <div className="col-md-8">
              {paymentDetails &&
                paymentDetails.map((rdata, index) => (
                  <div
                    className="bxShadow p-3 mt-4 mb-5 rwcard-containers d-flex flex-column"
                    key={rdata._id}
                    style={{ position: "relative" }}
                    ref={roomDetailsRef}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <h2>
                        {rdata?.hotelName || (
                          <Skeleton width={200} height={30} />
                        )}
                      </h2>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-3">
                        <img
                          src={rdata?.heroImage}
                          className="imgclass"
                          style={{ borderRadius: "8px", height: "auto" }}
                          loading="lazy"
                          alt="hotelimg"
                        />
                      </div>
                      <div className="col-md-9">
                        <p>{rdata?.starRating} - star Hotel</p>
                        {/* <div className="d-flex align-items-center justify-content-between">
                    <h2>{rdata.hotel.name}</h2>
                    <p style={{ color: "var(--primary-color)" }}>
                      Hotel details
                    </p>
                  </div> */}
                        <p
                          className="fs-8"
                          style={{ color: "var(--label-text-color)" }}
                        >
                          {rdata?.contact?.address?.line1} {""},
                          {rdata?.contact?.address?.city?.name} ,
                          {rdata?.contact?.address?.country?.name}
                        </p>
                        <p
                          className="fs-8"
                          style={{ color: "var(--label-text-color)" }}
                        >
                          Contact Number : {rdata?.contact?.phone}
                        </p>
                        <p className="fs-8 mt-1">
                          {rdata?.descriptions[0].text}
                        </p>
                      </div>
                    </div>

                    <div
                      style={{
                        maxHeight:
                          showRoomDetails === rdata.bookingId
                            ? `${
                                roomDetailsRef.current?.scrollHeight *
                                rdata?.rooms.length *
                                1000
                              }px`
                            : "0",
                        overflow: "hidden",
                        transition: "all 0.6s ease",
                      }}
                    >
                      {showRoomDetails === rdata.bookingId && (
                        <>
                          <hr
                            className="my-4"
                            style={{
                              background: "var(--light-grey)",
                              height: "1px",
                            }}
                          />
                          {rdata?.rooms.map((room, index) => (
                            <>
                              <p>Booking ID: {rdata?.bookingId}</p>
                              <div className="row mt-1 ">
                                <div className="col-md-3">
                                  <img
                                    src={room?.images}
                                    className="imgclass"
                                    style={{
                                      borderRadius: "8px",
                                      height: "auto",
                                    }}
                                    loading="lazy"
                                  />
                                </div>
                                <div className="col-md-9 ">
                                  <h3 className="mt-1">{room?.name}</h3>
                                  <p className="mt-1">{room?.refundability}</p>
                                  <div className="d-flex align-items-center justify-content-between mt-2 ">
                                    <div className="d-flex align-items-start justify-content-between ">
                                      <p
                                        style={{
                                          color: "var(--label-text-color)",
                                        }}
                                      >
                                        Check In:
                                      </p>
                                      <div className="ms-1">
                                        <p>
                                          {formatDateToEEE_MM_d(
                                            rdata?.checkIn,
                                            "UTC",
                                            "long"
                                          )}
                                        </p>
                                        <p
                                          className="fs-8"
                                          style={{
                                            color: "var(--label-text-color)",
                                          }}
                                        >
                                          {/* {rdata?.checkOut} */}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-start justify-content-between">
                                      <p style={{ color: "var(--light-grey)" }}>
                                        Check Out:
                                      </p>
                                      <div className="ms-1">
                                        <p>
                                          {" "}
                                          <p>
                                            {formatDateToEEE_MM_d(
                                              rdata?.checkOut,
                                              "UTC",
                                              "long"
                                            )}
                                          </p>
                                        </p>
                                        <p
                                          className="fs-8"
                                          style={{ color: "var(--light-grey)" }}
                                        >
                                          {rdata?.check_out_time}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    {room?.facilities.map((ramData) => (
                                      <div
                                        className="d-flex align-items-center"
                                        key={ramData?.name}
                                      >
                                        <p
                                          className="mt-1"
                                          style={{
                                            color: "var(--label-text-color)",
                                          }}
                                        >
                                          {ramData?.icon}
                                        </p>
                                        <p
                                          className="ms-2"
                                          style={{
                                            color: "var(--label-text-color)",
                                          }}
                                        >
                                          {ramData && ramData}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                  {room?.additionalCharges.length !== 0 && (
                                    <p
                                      className="mt-2"
                                      style={{ color: "var(--primary-color)" }}
                                    >
                                      {
                                        room?.additionalCharges[0]?.charge
                                          ?.description
                                      }{" "}
                                      : {room?.additionalCharges[0]?.text}
                                    </p>
                                  )}

                                  {room &&
                                    room?.cancellationPolicies &&
                                    room?.cancellationPolicies.length !== 0 && (
                                      <div>
                                        <hr className="mb-1 mt-3 hrColor" />
                                        <p
                                          style={{
                                            color: "var(--yellow-color)",
                                          }}
                                        >
                                          Cancellation Policy
                                        </p>
                                        <p className="fs-8">
                                          •{" "}
                                          {room?.cancellationPolicies[0]
                                            ?.value === 0
                                            ? "No cancellation fee "
                                            : ` A cancellation fee of  ${
                                                room?.cancellationPolicies[0]
                                                  ?.valueType === "Percentage"
                                                  ? `${room?.cancellationPolicies[0]?.rules[0].value}% of the total amount`
                                                  : `$${room?.cancellationPolicies[0]?.rules[0].value.toFixed(
                                                      2
                                                    )}`
                                              }`}{" "}
                                          will be charged if you cancel between{" "}
                                          {
                                            room?.cancellationPolicies[0]?.start.split(
                                              "T"
                                            )[0]
                                          }{" "}
                                          {room?.cancellationPolicies[0]?.start
                                            .split("T")[1]
                                            .split(":")
                                            .slice(0, 2)
                                            .join(":")}{" "}
                                          and{" "}
                                          {
                                            room?.cancellationPolicies[0]?.end.split(
                                              "T"
                                            )[0]
                                          }{" "}
                                          {room?.cancellationPolicies[0]?.end
                                            .split("T")[1]
                                            .split(":")
                                            .slice(0, 2)
                                            .join(":")}
                                        </p>
                                        <p className="fs-8">
                                          •{" "}
                                          {room?.cancellationPolicies[
                                            room?.cancellationPolicies.length -
                                              1
                                          ].value === 0
                                            ? "No cancellation fee "
                                            : ` 100% cancellation fee of  `}{" "}
                                          will be charged if you cancel after{" "}
                                          {
                                            room?.cancellationPolicies[0]?.end.split(
                                              "T"
                                            )[0]
                                          }{" "}
                                          {room?.cancellationPolicies[0]?.end
                                            .split("T")[1]
                                            .split(":")
                                            .slice(0, 2)
                                            .join(":")}
                                        </p>
                                      </div>
                                    )}
                                </div>
                              </div>

                              {room?.additionalInformation.length !== 0 && (
                                <div>
                                  <h3 className="ms-1 mt-3">Notices</h3>
                                  {room?.additionalInformation.map(
                                    (radI, index) => (
                                      <p className="fs-8 mt-2">
                                        • {radI?.text}
                                      </p>
                                    )
                                  )}
                                </div>
                              )}
                            </>
                          ))}
                        </>
                      )}
                    </div>

                    {/* Centered arrow icon at the bottom */}
                    <div
                      className="text-center mt-auto"
                      style={{
                        marginTop: "auto",
                        position: "absolute",
                        bottom: "-30px",
                        left: "50%",
                        right: 0,
                      }}
                    >
                      <span
                        onClick={() => toggleRoomDetails(rdata?.bookingId)}
                        style={{ cursor: "pointer", fontSize: "24px" }}
                      >
                        {showRoomDetails === rdata?.bookingId ? (
                          <img
                            src={ArrowUpIcon}
                            style={{
                              background: "var(--white-color)",
                              borderRadius: "50px",
                              padding: "10px",
                              width: "20px",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                            loading="lazy"
                          />
                        ) : (
                          <img
                            src={ArrowDownIcon}
                            style={{
                              background: "var(--white-color)",
                              borderRadius: "50px",
                              padding: "10px",
                              width: "20px",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                            loading="lazy"
                          />
                        )}
                      </span>
                    </div>
                  </div>
                ))}
            </div>

            <div className="col-md-4  mt-4 ">
              {billDetails?.billingDetails && (
                <div className="bxShadow rwcard-containers sticky-column ">
                  <div className="p-3">
                    <h4> Price Breakup</h4>
                    {billDetails?.billingDetails.map((bd, index) => (
                      <div className="d-flex align-items-center justify-content-between mt-3">
                        <div>
                          <p>{bd.hotelName}</p>
                          <p className="fs-8">
                            Rooms x {bd.roomDetails.length}
                          </p>
                        </div>
                        <p>
                          {/* {billDetails?.currency} */}${" "}
                          {bd?.totalHotelRate.toFixed(2)}
                        </p>
                      </div>
                    ))}
                    <div className="d-flex align-items-center justify-content-between mt-3 ">
                      <p>Tax Recovery Charges & Service Fees</p>
                      <p>
                        ${" "}
                        {(
                          Number(totalAmount) - Number(billDetails?.grandTotal)
                        ).toFixed(2)}
                      </p>
                    </div>

                    <hr
                      className="my-3"
                      style={{
                        backgroundColor: "var(--light-grey",
                        height: "1px",
                      }}
                    />
                    <div className="d-flex align-items-center justify-content-between ">
                      <p>Total</p>
                      <p>$ {totalAmount && totalAmount}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingConfirmation;
